module.exports = __webpack_public_path__ + "static/media/rabbit_city_background.693db505.png";


//////////////////
// WEBPACK FOOTER
// ./src/rabbitCity/static/rabbit_city_background.png
// module id = 508
// module chunks = 0